import {postRequest} from "./helper"
export const blogAddApi = (data) => postRequest('admin/add-blog',data);
export const blogListApi = (data) => postRequest('admin/list-blog',data);
export const blogUpdateApi = (data) => postRequest('admin/update-blog',data);
export const blogDeleteApi = (data) => postRequest('admin/remove-blog',data);



// WEBPACK FOOTER //
// ./src/api/Admin/Blog.js